import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-obsidian text-mist">
        <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.24em]">
          <span className="h-1.5 w-1.5 bg-teal animate-pulse-soft" />
          Awaiting clearance…
        </div>
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
